import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';


const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Trade list'

  }
];

@Component({
  selector: 'page-trade-list',
  templateUrl: './trade-list.html',
  styleUrls: ['./trade-list.scss']
})

export class PageTradeList implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  customerCtrl: FormControl;
  fetchCustomer=[];
  filteredCustomers: any;
  customers = [];
  rows = [];
  temp = [];
  model=[];
  public form: FormGroup;
  key:any="";keypart:any="";
  productCtrl:FormControl;
  productModels=[];
  filteredProducts:any;
  loadingIndicator: boolean = false;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/product-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/product-list-export.php";
  date_selected:any;
  keyDnFilter:boolean=false;
  keyKbFilter:boolean=false;
  keyDateFilter:boolean=false;
  keyFgFilter:boolean=false;
  keyPdFilter:boolean=false;
  keyPtFilter:boolean=false;
  keyRmFilter:boolean=false;
  st1:boolean=false; st2:boolean=false; st3:boolean=false; st4:boolean=false; st5:boolean=false; st6:boolean=false; st7:boolean=false; st8:boolean=false;

  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    let date = new Date();
    this.date_selected = date.toISOString().split('T')[0];
   // console.log('-------this.filteredStates-----',this.filteredStates);
   this.form = this.fb.group({
    keyKb: [null, Validators.compose([Validators.required])],
    keyDn: [null, Validators.compose([Validators.required])]
  });
    this._sharedService.emitChange(this.pageTitle);
  }


search(){ 
  this.loadingIndicator = true;
  let dialogRef = this.dialog.open(tradeListDialog, { disableClose: true });
  let instance = dialogRef.componentInstance;
  instance.Message = "wait.....";

  this.httpservice.fetchget('getJSON_trade_list.php?key='+this.form.controls.keyDn.value+'&date_selected='+this.date_selected,(data)=>{
          this.rows = data;
          this.temp = data;
          this.loadingIndicator = false;
          this.dialog.closeAll();
  });

  }

  ngOnInit() {}

  updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      
      return d.tp_part_no.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.knno.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
  
}


//dialog
@Component({
  selector: 'loading-dialog',
  templateUrl: 'loading-dialog.html',
})
export class tradeListDialog {
  public Message = 'Loading data...';
  constructor(public dialogRef: MdDialogRef<tradeListDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/trade-back/trade-list.ts